import el from "@cypherpotato/el";
import dayjs from "dayjs";
import { formatDateTime } from "../ui/format";
import { MutedText } from "./text";

export function DateTimeLabel(time) {
    return el(".datetime-label",
        el("time", formatDateTime(time), { datetime: time, title: time }),
        el("div",
            MutedText(
                el("small", dayjs(time).fromNow())
            )
        )
    )
}